<template>
  <div>
    <div>
      <div class="c-card-body">
        <datatable
          ref="datatable"
          module="reservation-pt"
          :title="title"
          :url="url"
          :columns="columns"
          :filter="filter"
          :on-click-create="onClickCreate"
          :on-click-update="onClickUpdate"
          :on-click-delete="onClickDelete"
          :action-width="180"
        >
        <template v-slot:[`item.is_cancelled_by_pt`]="{ item }">
            <div class="py-0">
              <v-chip
                v-if="item.is_cancelled_by_pt === true"
                color="red"
                text-color="white"
                small
              >
                Dibatalkan oleh PT
              </v-chip>
              <v-chip
                v-else
                color="green"
                text-color="white"
                small
              >
                Aktif
              </v-chip>
            </div>
          </template>
        <template v-slot:action>
            <v-col md="3">
              <v-autocomplete
                label="Member"
                required
                dense
                outlined
                v-model="filterMember"
                :items="listMembers"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col md="3">
              <v-autocomplete
                label="Personal Trainer"
                required
                dense
                outlined
                v-model="filterPersonalTrainer"
                :items="listPersonalTrainers"
                item-text="name"
                item-value="id"
                hide-details="true"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col md="3">
              <date-picker
                placeholder="Tanggal Reservasi"
                valueType="format"
                :format="'DD/MM/YYYY'"
                v-model="filterDate"
              ></date-picker>
            </v-col>
          </template>
        <template v-slot:[`item.reservation_date`]="{ item }">
            <div v-if="item.reservation_date != null">
              {{ item.reservation_date | moment("DD/MM/YYYY") }}
            </div>
            <div v-else>-</div>
          </template>
      </datatable>
      </div>
    </div>
    <form-data ref="form" module="reservation-pt" :success="formSuccess" />
    <delete-dialog
      ref="delete"
      url="reservation-pt"
      :success="deleteSuccess"
    ></delete-dialog>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import DeleteDialog from "@/view/component/DeleteDialog.vue";
import FormData from "./Form";
import Moment from "moment";
import ApiService from "@/core/services/api.service";

export default {
  async mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Member", route: "" },
      { title: "Reservation PT" }
    ]);

     this.filterBy();
    const members = await ApiService.get("user/list?role_slug=member");
    this.listMembers = members.data;

    const personalTrainers = await ApiService.get("user/list?role_slug=personal-trainer");
    this.listPersonalTrainers = personalTrainers.data;
  },
  data() {
    return {
      title: "Reservation PT",
      url: "reservation-pt/data",
      filterMember: null,
      filterPersonalTrainer: null,
      listMembers: [],
      listPersonalTrainers: [],
      filterDate: null,
      filter: null,
      columns: [
        {
          value: "id"
        },
        {
          text: "Tanggal",
          value: "reservation_date",
          sortable: true,
          searchable: false
        },
        {
          text: "Jam Mulai",
          value: "start_time",
          sortable: true,
          searchable: false
        },
        {
          text: "Jam Selesai",
          value: "end_time",
          sortable: true,
          searchable: false
        },
        {
          text: "Member",
          value: "member_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Personal Trainer",
          value: "personal_trainer_name",
          sortable: true,
          searchable: true
        },
        {
          text: "Dibatalkan oleh PT",
          value: "is_cancelled_by_pt",
          sortable: true,
          searchable: false
        },

      ]
    };
  },
  methods: {
    onClickCreate() {
      this.$refs.form.open();
    },
    onClickUpdate(item) {
      this.$refs.form.open(item.id);
    },
    onClickDelete(item) {
      this.$refs.delete.open(item.id);
    },
    formSuccess() {
      this.$refs.datatable.getData();
    },
    deleteSuccess() {
      this.$refs.datatable.getData();
    },
    filterBy() {
      let finalFilter = [];

      if (this.filterMember) {
        finalFilter = [
          ...finalFilter,
          {
            column: "member_id",
            value: this.filterMember,
          }
        ];
      }
      if (this.filterPersonalTrainer) {
        finalFilter = [
          ...finalFilter,
          {
            column: "personal_trainer_id",
            value: this.filterPersonalTrainer,
          }
        ];
      }
      if (this.filterDate) {
        finalFilter = [
          ...finalFilter,
          {
            column: "reservation_date",
            value: Moment(this.filterDate, "DD/MM/YYYY").format("YYYY-MM-DD"),
          }
        ];
      }

      if (finalFilter.length > 0) {
        this.filter = finalFilter;
      } else {
        this.filter = null;
        this.filterSlug = null;
      }
    },
  },
  watch: {
    filterMember(v) {
      if (v) {
        this.filterMember = v;
      } else {
        this.filterMember = null;
      }

      this.filterBy();
    },
    filterPersonalTrainer(v) {
      if (v) {
        this.filterPersonalTrainer = v;
      } else {
        this.filterPersonalTrainer = null;
      }

      this.filterBy();
    },
    filterDate(v) {
      if (v) {
        this.filterDate = v;
      } else {
        this.filterDate = null;
      }
      this.filterBy();
    }
    
  },
  components: {
    Datatable,
    DeleteDialog,
    FormData
  }
};
</script>
